import { setShowClientSiteModal } from '../State/showClientSiteModal';
import { clearClientSiteForEdit } from '../State/clientSiteForEdit';

export default () => async (dispatch) => {

  dispatch(setShowClientSiteModal(false))
  dispatch(clearClientSiteForEdit())
}
